<div class="op-loader-overlay" *ngIf="loaderService.loading$ | async">
  <div class="op-loader">
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
    <div class="circle"></div>
  </div>
  <!-- <p class="loader-text mt-4">Loading next question...</p> -->
</div>
